import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { Header } from '../../../../../../components/header';
import { useHorizontalScroll } from '../../../../../../modules/store/hooks/use-scroll';
import { ROUTES } from '../../../../../../routes';
import { TariffOperator } from '../../../channel-details/optimizer/configuration/types/tariff-kind';
import { AnimatedBox } from '../../components/animated-box/animated-box';
import { DashboardResourceItem, ObjectFitType } from '../../components/dashboard-resource-item/dashboard-resource-item';
import { useDashboardContext } from '../../context/dashboard-context';

export const DashboardResources: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('dashboard');
  const { scrollableRef } = useHorizontalScroll<HTMLDivElement>();
  const { tariffOperator } = useDashboardContext();
  const isTauron = tariffOperator === TariffOperator.Tauron;

  const data = [
    ...(isTauron
      ? [
          {
            title: t('resources.tauronG13s.title'),
            subTitle: t('resources.tauronG13s.subTitle'),
            imagePath: '/images/g13s.png',
            onClick: () => navigate(ROUTES.TauronG13s()),
            objectFit: ObjectFitType.Contain,
          },
        ]
      : []),
    {
      title: t('resources.shop.title'),
      subTitle: t('resources.shop.subTitle'),
      imagePath: 'https://updates.tr7.pl/supportedDevices/lavva/lavva-double.png',
      onClick: () => navigate(ROUTES.Store()),
      objectFit: ObjectFitType.Cover,
    },
    {
      title: t('resources.groups.title'),
      subTitle: t('resources.groups.subTitle'),
      imagePath: 'images/smart-home.png',
      onClick: () => navigate(ROUTES.GroupsOverview()),
      objectFit: ObjectFitType.Cover,
    },
    {
      title: t('resources.instructions.title'),
      subTitle: t('resources.instructions.subTitle'),
      imagePath: 'images/instructions.png',
      onClick: () => navigate(ROUTES.Instructions()),
      objectFit: ObjectFitType.Cover,
    },
  ];

  return (
    <AnimatedBox marginBottom={6} paddingLeft={3}>
      <Header title={t('resources.header')} />
      <Stack direction="row" gap={3} overflow="auto" flexWrap="nowrap" ref={scrollableRef} paddingRight={3}>
        {data.map((resource) => (
          <DashboardResourceItem key={resource.title} {...resource} />
        ))}
      </Stack>
    </AnimatedBox>
  );
};
